import { render, staticRenderFns } from "./ModalDemo.vue?vue&type=template&id=113120b9&"
import script from "./ModalDemo.vue?vue&type=script&lang=js&"
export * from "./ModalDemo.vue?vue&type=script&lang=js&"
import style0 from "./ModalDemo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports